import { render, staticRenderFns } from "./ViewDataCon.vue?vue&type=template&id=b9f3882a&scoped=true"
import script from "./ViewDataCon.vue?vue&type=script&lang=js"
export * from "./ViewDataCon.vue?vue&type=script&lang=js"
import style0 from "./ViewDataCon.vue?vue&type=style&index=0&id=b9f3882a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f3882a",
  null
  
)

export default component.exports